import * as React from 'react';
import styled from 'styled-components';
import { StyledTab } from '../Tabs/TabList';

const StyledSelectIcon = styled.svg`
    circle {
        fill: ${({ theme }) => theme.colors.charcoal20};

        ${StyledTab}[data-selected='true'] & {
            fill: ${({ theme }) => theme.colors.turquoise100};
        }
    }

    path {
        stroke: ${({ theme }) => theme.colors.charcoal2};
    }
`;

const SelectIcon = (props: React.SVGAttributes<SVGElement>) => (
    <StyledSelectIcon
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <circle cx="7.5" cy="7.5" r="7.5" />
        <path d="M5 7.33333L6.78571 9L10 6" strokeLinecap="round" />
    </StyledSelectIcon>
);

export default SelectIcon;
